// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__7Q0_F","inner":"Footer_inner__1Lr1D","nextIcon":"Footer_nextIcon__1BE_C","innerLeft":"Footer_innerLeft__3rq-n"};